import { extendsModule, baseFormItem } from 'src/store/base';

export default extendsModule(baseFormItem, {
  state: {
    _moduleKey: 'playable-name',
    name: '',
  },
  getters: {
    formItemData(state) {
      return {
        name: state.name,
      };
    },
  },
  actions: {
    data2State({ commit }, formData) {
      commit('update', {
        name: formData.name || '',
      });
    },
  },
});
